<template>
  <div>
  <div class="explain">
    <div class="use">
      <greentitle titleText="使用说明" />
      <div class="content">
        <p>1.身份证票可持购票时的身份证原件，验证件入园</p>
        <p>2.二维码票请在入园前提前准备好二维码，出示购票相关的证件，刷二维码入园</p>
      </div>
    </div>
    <div class="use mt-50">
      <greentitle titleText="退票规则" />
      <div class="content">
        <p>1.已使用门票不予退票。</p>
        <p>2.未使用门票在游览当日前可随时退票。</p>
        <p>3.当日未使用门票，自游览之日起7天内可退。（游览日为第一日）</p>
      </div>
    </div>


    <!-- <div class="use mt-50">
      <greentitle titleText="客服电话" />
      <div class="content">
        <p>天坛公园客服电话：xxx</p>
      </div>
    </div> -->
  </div>
  <div class="explain" v-if="showBank">
    <img  class="bank" src="../../../assets/image/explain/bank.jpg" alt="">
  </div>
</div>

</template>

<script>
export default {
  name: "explain",
  props: {
    itemList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showBank: function() {
      let bool = this.itemList.some(item => item.ticketStatus === '2')
      return bool
    }
  }
};
</script>

<style scoped lang='less'>
.explain{
  padding: .293333rem .32rem;
  background: #FFFFFF;
  margin: .333333rem 0.346667rem 0;
  box-shadow: 0 .133333rem .08rem rgba(0, 0, 0, 0.01);
  border-radius: .08rem;
  .use{
    text-align: justify;
    .content{
      font-size: .4rem;
      color: rgba(58, 62, 92, .8);
      margin-top: .266667rem;
    }
  }
  .mt-50{
    margin-top: .666667rem;
  }
  .bank {
    display: block;
    height: 80px;
    margin: 0 auto;
  }
}
</style>
